import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { ProductOfTheWeekManagement } from "../../components/ProductOfTheWeekManagement/ProductOfTheWeekManagement";
import ShopByCatsManagement from "../../components/ShopByCatsManagement/ShopByCatsManagement";
import SelectionBannersManagement from "../../components/SelectionBannersManagement/SelectionBannersManagement";
import BottomBannersManagement from "../../components/BottomBannersManagement/BottomBannersManagement";
import API from "../../network/dashboardAPI";
import { Tab, Tabs } from "react-bootstrap";
import HomePageVideoManagement from "../../components/HomePageVideoManagerment/HomePageVideoManagement";
import ReviewCard from "./reviewCard";


const HomePageSettings = () => {

    return (
        <HomePageManagement>
            <Tabs>
                <Tab eventKey={0} title='Product of The Week'>
                    <ComponentContainer>
                        <ProductOfTheWeekManagement/>  
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={1} title='Shop by Category'>
                    <ComponentContainer>
                        <ShopByCatsManagement/>
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={2} title='Selection Banner'>
                    <ComponentContainer>
                        <SelectionBannersManagement/>
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={3} title='Video HomePage'>
                    <ComponentContainer>
                        <HomePageVideoManagement />
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={5} title='Bottom Banner'>
                    <ComponentContainer>
                        <BottomBannersManagement/>
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={6} title='Review Card'>
                    <ComponentContainer>
                        <ReviewCard />
                    </ComponentContainer>
                </Tab>
            </Tabs>
                     
        </HomePageManagement>
    )
}

const HomePageManagement = styled.div`
    margin: 30px 15px;
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

    nav {
        border-bottom: 1px solid #dee2e6 !important;
    }


    .nav.nav-tabs .nav-item.nav-link.active {
        color: #007bff;
    }
    .nav.nav-tabs .nav-item.nav-link{
        color: #495057;

    }
`

const ComponentContainer =styled.div`
    padding: 20px;
    border: 1px solid #dee2e6;
    border-top: none;
`;

 const Tittle = styled.h4`
    margin-bottom: 10px;
`

export default HomePageSettings;